import type ActiveChannel from '@/common/interfaces/ActiveChannel'
import {injectable} from 'inversify'

@injectable()
export default class ActiveChannelApplicant implements ActiveChannel {
  type: "APPLICANT"
  constructor() {
    this.type = "APPLICANT"
  }
}
